import { render, staticRenderFns } from "./StatusSettingsDialog.vue?vue&type=template&id=65e87d69&scoped=true"
import script from "./StatusSettingsDialog.vue?vue&type=script&lang=ts"
export * from "./StatusSettingsDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e87d69",
  null
  
)

export default component.exports